import * as yup from 'yup';
import { AclAction } from 'shared/domains/apollo/generated/types';
const actionSchema = yup
    .array()
    .of(yup.string().oneOf([AclAction.Read, AclAction.Write, AclAction.Delete, AclAction.Traverse]))
    .min(1)
    .required();
export const teamAclSchema = yup.object({
    id: yup.string(),
    teamId: yup.string().required(),
    actions: actionSchema,
});
export const userAclSchema = yup.object({
    id: yup.string(),
    userId: yup.string().required(),
    actions: actionSchema,
});
export const accessManagementSchema = yup.object({
    userAcls: yup.array().of(userAclSchema),
    teamAcls: yup.array().of(teamAclSchema),
});
